import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b74b9164&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.scss?vue&type=style&index=0&id=b74b9164&prod&scoped=true&lang=scss&external"
import style1 from "./index.vue?vue&type=style&index=1&id=b74b9164&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74b9164",
  null
  
)

export default component.exports